<template>
    <div id="js-user-wrap" class="container">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="box-card-title">证书列表</span>
                <router-link to="/home">
                    <el-button size="small" type="primary" class="return-button"><i class="fa fa-home"></i>返回首页</el-button>
                </router-link>
                <router-link to="/cpePolicy">
                    <el-button size="small" type="primary" class="return-button">证书维持政策</el-button>
                </router-link>
                <router-link to="/cpeApply">
                    <el-button size="small" type="primary" class="return-button">CPE申报</el-button>
                </router-link>
                <router-link to="/cpeActivity">
                    <el-button size="small" type="primary" class="return-button">CPE近期活动</el-button>
                </router-link>
            </div>


            <p v-if="isLogin && certificateList.length === 0">您还没有通过CSA CCSK、CDSP、CDPO、CZTP、CCPTP、CBP任一认证科目考试，请通过相关考试后，再进行证书维持</p>

<!--            <div v-if="!isLogin" style="display: flex;justify-content: center;align-items: center" >-->
            <div v-if="!isLogin" >
                <span style="color: #909399;" >请登录考试账号，查看您已获得的证书信息</span>
            </div>

            <el-card class="box-card" v-for="item in certificateList" :key="item.id">
                <el-row :gutter="20" style="margin: 10px 0px 20px 0px">
                    <el-col :span="4">
                        <img :src="item.pictureUrl"  width="100%"/>
                    </el-col>
                    <el-col :span="20">
                        <h2>{{item.certificateName}}</h2>
<!--                        不需要维持-->
                        <div style="margin:10px 0px 20px 0px" v-if="item.status===0">
                            <p style="margin-top: 15px">证书编号：{{item.certificateNo}}</p>
                            <p style="margin-top: 15px" >获证时间：{{item.awardTime}}</p>
                            <p style="margin-top: 15px" >无需证书维持</p>
                        </div>
<!--                        已失效-->
                        <div style="margin:10px 0px 20px 0px" v-if="item.status===-1">
                            <p style="margin-top: 15px">证书编号：{{item.certificateNo}}(已失效)</p>
                            <p style="margin-top: 15px">有&numsp;效&numsp;期：{{item.awardTime}}-{{item.expireTime}}</p>
                        </div>
<!--                        未进入维持期-->
                        <div style="margin:10px 0px 20px 0px" v-if="item.status === 1">
                            <p style="margin-top: 15px">证书编号：{{item.certificateNo}}</p>
                            <p style="margin-top: 15px" >有&numsp;效&numsp;期：{{item.awardTime}}-{{item.expireTime}}</p>
                            <p v-if="item.enableCpeDiscounts">累计CPE：
                                <span style="font-size: 30px; color: #008ab8; font-weight: bold; margin-right: 20px">{{ item.cpeNum}}</span>
                                <el-button v-if="item.cpeNum > 0" type="text" @click="showCpe(item.id)">查看明细</el-button>
                                <router-link v-if="item.cpeNum === 0" to="/cpeApply">
                                    <el-button  type="text">立即申报</el-button>
                                </router-link>
                            </p>
                            <p>维持费用：
                                <span style="font-size: 30px; color: red; font-weight: bold; margin-right: 5px">¥{{item.actuallyPrice}}</span>
                                <el-tooltip placement="top" effect="light" style="border-width: 0px">
                                    <div slot="content">
                                        <div v-if="!item.old">
                                            原&numsp;&numsp;&numsp;价：¥{{ item.price}}<br/>
                                            CPE抵扣：¥{{ item.cpeDiscounts }}
                                        </div>
                                        <div v-if="item.old">
                                            优&numsp;惠&numsp;价：¥{{ item.price}}
                                        </div>
                                    </div>
                                    <i class="el-icon-question" style="margin-right: 20px;color: #82848a"></i>
                                </el-tooltip>
                                <el-tooltip placement="top" effect="light" style="border-width: 0px">
                                    <div slot="content">请等待至下次证书维持日期后再支付费用</div>
                                    <el-button style="color: #c0c4cc" type="text">费用支付</el-button>
<!--                                    <i class="el-icon-question" style="margin-right: 20px;color: #82848a"></i>-->
                                </el-tooltip>
                            </p>
                            <p style="margin-top: 15px;">下次证书维持日期：{{item.nextStartDate}} - {{item.nextEndDate}}
                                <el-tooltip placement="top" effect="light" style="border-width: 0px">
                                    <div slot="content" style="padding-left: 10px">
                                        <ol>
                                            <li v-if="item.subjectId !== 9">证书维持费用支付有效时间：证书到期前3个月至证书到期后3个月内</li>
                                            <li v-if="item.subjectId === 9">证书维持费用支付有效时间：证书到期前6个月至证书到期后3个月内</li>
                                            <li>在证书过期3个月至1年间可继续维持证书，但除证书维持费用外，需另缴纳500元滞纳费用</li>
                                            <li>证书过期1年以上的需要重新参加考试，不能办理证书维持。</li>
                                        </ol>
                                    </div>
                                    <i class="el-icon-question" style="margin-right: 20px;color: #82848a"></i>
                                </el-tooltip>
<!--                                <span style="color: #82848a">（需在此日期范围之内支付）</span>-->
                            </p>
                        </div>
<!--                        已进入维持期-->
                        <div style="margin:10px 0px 20px 0px" v-if="item.status===2">
                            <p style="margin-top: 15px">证书编号：{{item.certificateNo}}</p>
                            <p style="margin-top: 15px" >有&numsp;效&numsp;期：{{item.awardTime}}-{{item.expireTime}}</p>
                            <p v-if="item.enableCpeDiscounts">累计CPE：
                                <span style="font-size: 30px; color: #008ab8; font-weight: bold; margin-right: 20px">{{ item.cpeNum}}</span>
                                <el-button v-if="item.cpeNum > 0" type="text" @click="showCpe(item.id)">查看明细</el-button>
                                <router-link v-if="item.cpeNum === 0" to="/cpeApply">
                                    <el-button  type="text">立即申报</el-button>
                                </router-link>
                            </p>
                            <p>维持费用：
                                <span style="font-size: 30px; color: red; font-weight: bold; margin-right: 5px">¥{{item.actuallyPrice}}</span>
                                <el-tooltip placement="top" effect="light" style="border-width: 0px">
                                    <div slot="content">
                                        <div v-if="!item.old">
                                            原&numsp;&numsp;&numsp;价：¥{{ item.price}}<br/>
                                            CPE抵扣：¥{{ item.cpeDiscounts }}
                                        </div>
                                        <div v-if="item.old">
                                            优&numsp;惠&numsp;价：¥{{ item.price}}
                                        </div>
                                    </div>
                                    <i class="el-icon-question" style="margin-right: 20px;color: #82848a"></i>
                                </el-tooltip>
                                <el-button v-if="!item.paySuccess" type="text" @click="toPay(item)">费用支付</el-button>
                                <span v-if="item.paySuccess" style="color: #82848a">(已支付，证书将于{{item.renewDate}}更新)</span>
                            </p>
                            <p style="margin-top: 15px;">证书维持截止日期：{{item.nextEndDate}}
                                <el-tooltip placement="top" effect="light" style="border-width: 0px">
                                    <div slot="content" style="padding-left: 10px">
                                        <ol>
                                            <li v-if="item.subjectId !== 9">证书维持费用支付有效时间：证书到期前3个月至证书到期后3个月内</li>
                                            <li v-if="item.subjectId === 9">证书维持费用支付有效时间：证书到期前6个月至证书到期后3个月内</li>
                                            <li>在证书过期3个月至1年间可继续维持证书，但除证书维持费用外，需另缴纳500元滞纳费用</li>
                                            <li>证书过期1年以上的需要重新参加考试，不能办理证书维持。</li>
                                        </ol>
                                    </div>
                                    <i class="el-icon-question" style="margin-right: 20px;color: #82848a"></i>
                                </el-tooltip>
<!--                                <span style="color: #82848a">（{{item.nextEndDate}}后将产生滞纳金,{{item.disableDate}}后需重新考试）</span>-->
                            </p>
                        </div>

                        <div style="margin:10px 0px 20px 0px" v-if="item.status===3">
                            <p style="margin-top: 15px">证书编号：{{item.certificateNo}}</p>
                            <p style="margin-top: 15px" >有&numsp;效&numsp;期：{{item.awardTime}}-{{item.expireTime}}</p>
                            <p v-if="item.enableCpeDiscounts">累计CPE：
                                <span style="font-size: 30px; color: #008ab8; font-weight: bold; margin-right: 20px">{{ item.cpeNum}}</span>
                                <el-button type="text" @click="showCpe(item.id)">查看明细</el-button>
                            </p>
                            <p>维持费用：
                                <span style="font-size: 30px; color: red; font-weight: bold; margin-right: 5px">¥{{item.actuallyPrice}}</span>
                                <el-tooltip placement="top" effect="light" style="border-width: 0px">
                                    <div slot="content">
                                        <div v-if="!item.old">
                                            原&numsp;&numsp;&numsp;价：¥{{ item.price}}<br/>
                                            滞&numsp;纳&numsp;金：¥{{item.overdue}}<br/>
                                            CPE抵扣：¥{{ item.cpeDiscounts }}
                                        </div>
                                        <div v-if="item.old">
                                            优&numsp;惠&numsp;价：¥{{ item.price}}<br/>
                                            滞&numsp;纳&numsp;金：¥{{item.overdue}}<br/>
                                        </div>
                                    </div>
                                    <i class="el-icon-question" style="margin-right: 20px;color: #82848a"></i>
                                </el-tooltip>
                                <el-button v-if="!item.paySuccess" type="text" @click="toPay(item)">费用支付</el-button>
                                <span v-if="item.paySuccess" style="color: #82848a">(已支付，证书将于{{item.renewDate}}更新)</span>
                            </p>
                            <p style="margin-top: 15px;">证书维持失效日期：{{item.disableDate}}
                                <el-tooltip placement="top" effect="light" style="border-width: 0px">
                                    <div slot="content" style="padding-left: 10px">
                                        <ol>
                                            <li v-if="item.subjectId !== 9">证书维持费用支付有效时间：证书到期前3个月至证书到期后3个月内</li>
                                            <li v-if="item.subjectId === 9">证书维持费用支付有效时间：证书到期前6个月至证书到期后3个月内</li>
                                            <li>在证书过期3个月至1年间可继续维持证书，但除证书维持费用外，需另缴纳500元滞纳费用</li>
                                            <li>证书过期1年以上的需要重新参加考试，不能办理证书维持。</li>
                                        </ol>
                                    </div>
                                    <i class="el-icon-question" style="margin-right: 20px;color: #82848a"></i>
                                </el-tooltip>
<!--                                <span style="color: #82848a">（{{item.disableDate}}后需重新考试）</span>-->
                            </p>
                        </div>

                        <el-button v-if="item.status !==-1" size="small" type="primary" @click="downLoadCertificate(item.id)">证书下载<i class="el-icon-download el-icon--right"></i></el-button>
                    </el-col>
                </el-row>
            </el-card>
        </el-card>

        <el-dialog title="选择支付方式" :visible.sync="payInfoVisible" center>
            <div style="text-align:center;padding-top: 25px;">
                <div v-if="enableAlipay" class="pay-way alipay" @click="payWay=1" :class="{ active: payWay===1}">
                    <div class="triangle">
                        <i class="el-icon-check"></i>
                    </div>
                </div>
                <div v-if="enableWxpay" class="pay-way wxpay" @click="payWay=2" :class="{ active: payWay===2}">
                    <div class="triangle">
                        <i class="el-icon-check"></i>
                    </div>
                </div>
            </div>
            <div class="pay-bottom">
                <div>应付金额：<span class="red" >￥{{orderParam.price}}</span></div>
                <el-button @click="createOrder()"  type="warning" class="to-pay">立即支付</el-button>
            </div>
        </el-dialog>
        <el-dialog title="CPE明细" :visible.sync="cpeListVisible" width="100%">
            <el-table :data="cpeList" style="width: 100%" show-summary sum-text="总计">
                <el-table-column fixed fit prop="categoryName" label="项目名称"  ></el-table-column>
                <el-table-column prop="categoryParentName" label="类别" ></el-table-column>
                <el-table-column prop="startTime" label="开始时间" width="120" align="center" :formatter="dateFormat"></el-table-column>
                <el-table-column prop="endTime" label="结束时间" width="120" align="center"  :formatter="dateFormat"></el-table-column>
                <el-table-column prop="expiredTime" label="失效时间" width="120" align="center"  :formatter="dateFormat"></el-table-column>
                <el-table-column prop="num" label="CPE" width="80" align="center"></el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>
<script>
import VueQr from 'vue-qr'
export default {
    components:{VueQr},
    data:()=>{
        return {
            payInfoVisible: false,
            enableWxpay: false,
            enableAlipay: false,
            payWay: 1,
            orderParam:{
                price: 0,
            },
            certificateList:[],
            cpeList:[],
            cpeListVisible:false,
        };
    },
    created() {
        this.config()
        if(this.$store.state.userInfo && this.$store.state.userInfo.chName) {
            this.getData();
        }
    },
    computed: {
        systemConfig : function () {
            return this.$store.state.systemConfig;
        },
        isLogin: function() {
            return this.$store.state.userInfo&&this.$store.state.userInfo.chName ? true: false;
        },
    },
    methods: {
        async config() {

        },
        async getData() {
            let res = await this.$axios.get('/certificate/selectAll');
            if (res.code == 200) {
                this.certificateList = res.data;                  //订单列表
            }
        },
        async showCpe(id) {
            let res = await this.$axios.get(`/cpe/select?certificateId=${id}`);
            if (res.code == 200) {
                this.cpeList = res.data;
            }
            this.cpeListVisible=true;
        },
        async toPay(item) {
            let res = await this.$axios.get('/systemConfig/getSystemConfig');
            if (res.code != 200) {
                return;
            }
            let systemConfig = res.data;
            this.enableWxpay = systemConfig.enableWxpay;
            this.enableAlipay = systemConfig.enableAlipay;
            if (!systemConfig.enableWxpay && !systemConfig.enableAlipay) {
                this.payTipsVisible = true;
            } else {
                this.orderParam = {
                    price: item.actuallyPrice,
                    certificateId:item.id,
                }
                this.payInfoVisible = true;
            }
        },
        async createOrder() {
            if(!this.payWay){
                return;
            }
            const loading = this.$loading({
                lock: true,
                text: "正在创建订单，请稍后...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
            let res =  await this.$axios.post('/order/createOrder',
                {type:2,payChannel:this.payWay, certificateId:this.orderParam.certificateId}
            );
            loading.close();
            //当前科目存在待支付订单
            if (res.code == 601) {
                this.$confirm('当前证书存在待支付订单,立即前往订单中心处理？','提示', {
                    confirmButtonText: '前往',
                    cancelButtonText: '取消',
                    showClose: false,
                    type: 'warning'
                }).then(() => {
                    this.$router.push("order");
                }).catch(()=>{});
                return;
            }

            if (res.code == 200) {
                this.$router.push("order");
            }
        },
        downLoadCertificate(certificateId) {
            window.location.href = `/api/record/download/Certificate?certificateId=${certificateId}`;
        },
        dateFormat(row, column, dateTime, index) {
            if (dateTime) {
                return dateTime.substring(0,10);
            } else {
                return dateTime;
            }
        },
    },
    mounted() {

    }
};
</script>


<style scoped>
.el-icon-check{
    position: relative;
    left: -12px;
    top: 3px;
    color: #fff;
}
.triangle{
    opacity: 0;
    width: 0;
    height: 0;
    border-bottom: 20px solid red;
    border-left: 20px solid transparent;
    position: absolute;
    bottom: 0;
    right: 0;
}
.to-pay{
    background: #f01414;
    border-radius: 0;
    width: 140px;
    height: 40px;
}
.pay-bottom{
    text-align: right;
    color: #07111b;
    line-height: 40px;
    padding-top: 10px;
}
.red{
    color:#f01414;
    font-size: 24px;
}
.pay-way{
    position: relative;
    border-radius: 6px;
    overflow: hidden;
    width: 192px;
    height: 86px;
    background-color: #f3f5f7;
    border: 2px solid #f3f5f7;
    cursor: pointer;
    background-image: url(../assets/pay_s.png);
    display: inline-block;
}

.pay-way.alipay{
    background-position: 33px -304px;
    background-repeat: no-repeat;
    margin-right: 46px;
}

.pay-way.wxpay{
    background-position: 30px -423px;
    background-repeat: no-repeat;
}
.pay-way.active{
    border-color: #f01414;
}
.pay-way.active .triangle{
    opacity: 1;
}
.tips{
    color:#f01414;
    font-size: 14px;
    margin-top: 7px;
}
.container {
    margin-left: auto;
    margin-right: auto;
    max-width: 1300px;
}
.box-card {
    width: 100%;
    margin-top: 10px;
}
.el-input {
    width: 80%;
}
.return-button {
    float: right;
    margin-left: 20px;
}
@media screen and (max-width: 767px) {
    .el-card {
        box-shadow: none;
        border: none;
    }
}
</style>
